module.exports = [
	{
		"description": "This release includes support for migrating to the new Lock 11. You can find more in the migration guide <a href=\"https://auth0.com/docs/libraries/lock/v11/migration-guide\" rel=\"external\">https://auth0.com/docs/libraries/lock/v11/migration-guide</a>.",
		"type": "added",
		"module": "Appliance",
		"release": "14591",
		"team": [
			"crew-auth"
		],
		"publishedAt": "2017-12-20"
	},
	{
		"description": "The webtask sandbox dedicated domain is now added to the list of resolvable domain names from within a webtask sandbox.",
		"type": "fixed",
		"module": "Appliance",
		"release": "14591",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2017-12-20"
	},
	{
		"description": "Fixed an issue where the images-extra package was not updated if the kernel was updated when security updates were applied.",
		"type": "fixed",
		"module": "Appliance",
		"release": "14591",
		"team": [
			"tshak"
		],
		"publishedAt": "2017-12-20"
	},
	{
		"description": "Returned cache-control headers were updated to ensure sensitive data would not be cached on the local browser.",
		"type": "fixed",
		"module": "Appliance",
		"release": "14591",
		"team": [
			"crigot"
		],
		"publishedAt": "2017-12-20"
	},
	{
		"description": "The switch-tenant UI choice is enabled even if the 'Add New Accounts' option is disabled as long as are multiple active tenants.",
		"type": "fixed",
		"module": "Appliance",
		"release": "14591",
		"team": [
			"crew-2"
		],
		"publishedAt": "2017-12-20"
	},
	{
		"description": "Fixed an issue in 6-node clusters where nodes not configured to run Elastcisearch were attempting to configure logs and log rotation for Elasticsearch and failing.",
		"type": "fixed",
		"module": "Appliance",
		"release": "14591",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-12-20"
	},
	{
		"description": "Fixed an issue in a GeoHA setup with Elasticsearch, nodes may not be configured to use correct, local Elasticsearch cluster.",
		"type": "fixed",
		"module": "Appliance",
		"release": "14591",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-12-20"
	},
	{
		"description": "Fixed an issue in the NGINX configuration that allowed bypassing restricted access to the /login page in manage when using Basic Authentication with a port number in the Host Header.",
		"type": "fixed",
		"module": "Appliance",
		"release": "14591",
		"team": [
			"crigot"
		],
		"publishedAt": "2017-12-20"
	},
	{
		"description": "Elasticsearch indexes are now recreated with the proper number of replicas during the initial setup or, in a GeoHA setup, when re-indexes occurs in the non-primary region.",
		"type": "fixed",
		"module": "Appliance",
		"release": "14591",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-12-20"
	},
	{
		"description": "The appliance now supports the ability to apply configuration and future updates to nodes in sequential order. This will reduce downtime as only one node is reconfigured or updated while other nodes continue to server requests.",
		"type": "added",
		"module": "Appliance",
		"release": "14591",
		"team": [
			"pablo.terradillos",
			"tshak"
		],
		"publishedAt": "2017-12-20"
	},
	{
		"description": "The instrumentation value auth0_http_requests_replied is now summarized properly in the 1week statistics for Instrumentation.",
		"type": "fixed",
		"module": "Appliance",
		"release": "13896",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-10-20"
	},
	{
		"description": "Instrumentation will properly disabled when configured to do so.",
		"type": "fixed",
		"module": "Appliance",
		"release": "13896",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-10-20"
	},
	{
		"description": "Secrets used to communicate with MFA components are now properly rotated on initial appliance setup.",
		"type": "fixed",
		"module": "Appliance",
		"release": "13896",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-10-20"
	},
	{
		"description": "The component monitoring Elasticsearch zones in an appliance GeoHA setup no longer leaks connections and eventually restarts.",
		"type": "fixed",
		"module": "Appliance",
		"release": "13896",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-10-20"
	},
	{
		"description": "The Monthly-Active-User intermediate database storage is now retained and synchronzied betweed nodes calculating MAU to avoid the need to recreate this database.",
		"type": "new",
		"module": "Appliance",
		"release": "13896",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-10-20"
	},
	{
		"description": "Configuration time should be faster for some configurations due to not restarting components of the webtask rule execution sandbox. This will also make restart times faster for any reboots.",
		"type": "new",
		"module": "Appliance",
		"release": "13896",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-10-20"
	},
	{
		"description": "Updates initiated from the UI appear to be delayed by 1 minute. The attempt to upload stats was not shutting down cleanly and causing a delay in starting the update. Stats are now given 10 seconds to upload at the start of an update.",
		"type": "fixed",
		"module": "Appliance",
		"release": "13451",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2017-09-14"
	},
	{
		"description": "Collecting environment settings during update no longer causes auth0-start to abort update.",
		"type": "fixed",
		"module": "Appliance",
		"release": "13451",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2017-09-14"
	},
	{
		"description": "auth0-start no longer increases CPU eventualy during service checks when Elasticsearch is installed",
		"type": "fixed",
		"module": "Appliance",
		"release": "13451",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2017-09-14"
	},
	{
		"description": "Sensitive data backups no longer will include auth db.",
		"type": "fixed",
		"module": "Appliance",
		"release": "13451",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-09-14"
	},
	{
		"description": "Webtask components have been updated to 23.3.9",
		"type": "added",
		"module": "Appliance",
		"release": "13451",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-09-14"
	},
	{
		"description": "Webtask may now be configured on a dedicated domain. This mirrors how the cloud handles webtask domains and enables safely using extensions in shared-tenant environments. This will require setting up new DNS entries for the new domain and valid, trusted certificates.",
		"type": "added",
		"module": "Appliance",
		"release": "13451",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-09-14"
	},
	{
		"description": "auth0-stats now reports total internal users in the stats it collects. Note: This will eventually be seen in Support Center.",
		"type": "added",
		"module": "Appliance",
		"release": "13451",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-09-14"
	},
	{
		"description": "auth0-stats is updated to consider internal users when calculating Monthly Active Users (MAU). Note: This requires a CSE to set the internal user domain properly.",
		"type": "added",
		"module": "Appliance",
		"release": "13451",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-09-14"
	},
	{
		"description": "Many Auth0 extensions were fixed to add a login flow for access to extension information. This means that extensions will not work without webtask being deployed in a full-trust model. This model is not recommended for multi-tenant applications of the appliance. The extensions affected are:<br/> <ul><li>auth0-delegated-administration-extension</li><li>auth0-logs-to-logstash</li><li>  auth0-logs-to-papertrail</li><li>auth0-logs-to-loggly</li><li>auth0-logs-to-sumologic</li><li>auth0-delegated-admin-extension-nlg</li><li>auth0-logs-to-azure-blob-storage</li><li>auth0-logs-to-splunk</li><li>auth0-gitlab-deploy</li><li> auth0-logs-to-application-insights</li><li>auth0-github-deploy</li><li> auth0-visualstudio-deploy</li><li> auth0-bitbucket-deploy</li><li> auth0-box-platform-extension</li></ul>",
		"type": "fixed",
		"module": "Appliance",
		"release": "13130",
		"team": [
			"auth0-extensions team"
		],
		"publishedAt": "2017-08-16"
	},
	{
		"description": "Database backups done through the CLI are now done in quiet mode to avoid over-filling the response buffer (and prematurely terminating the backup job).",
		"type": "fixed",
		"module": "Appliance",
		"release": "13130",
		"team": [
			"rikaard.hosein"
		],
		"publishedAt": "2017-08-16"
	},
	{
		"description": "Daily stats for the last 7 days now appears in the dashboard correctly.",
		"type": "fixed",
		"module": "Appliance",
		"release": "13130",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-08-16"
	},
	{
		"description": "Auth0-sandbox webtask containers no longer log within the container, which could potentially consume more disk space than necessary since logs are kept elsewhere.",
		"type": "fixed",
		"module": "Appliance",
		"release": "13130",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2017-08-16"
	},
	{
		"description": "Tenant logs can now be offloaded to an external endpoint over TCP/HTTP. This can support many endpoints that supprt this, including logstash and Splunk. If using TLS/HTTPS it does require a valid certificate on the receiving service.",
		"type": "added",
		"module": "Appliance",
		"release": "13130",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-08-16"
	},
	{
		"description": "The local appliance domain is now reachable within auth0-sandbox containers. This eliminates the need to make the appliance domain endpoints resolvable and reachable by public DNS.",
		"type": "added",
		"module": "Appliance",
		"release": "13130",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2017-08-16"
	},
	{
		"description": "Legacy grant types are deprecated. New tenants and clients do not support these grant types by default, but they can be enabled. See this https://auth0.com/docs/clients/client-grant-types for more details on grant types.",
		"type": "added",
		"module": "Appliance",
		"release": "12628",
		"team": [
			"pablo.terradillos",
			"damian.fortuna"
		],
		"publishedAt": "2017-07-01"
	},
	{
		"description": "The appliance now supports Multi-Factor Authentication with SMS and Push Notifications. Mobile clients can be built with the Guardian SDK that will work with the appliance. The appliance does _not_ support the Auth0-branded Guardian client. See https://auth0.com/docs/multifactor-authentication for using and configuration Multi-Factor Authentication.",
		"type": "added",
		"module": "Appliance",
		"release": "12628",
		"team": [
			"pablo.terradillos",
			"damian.fortuna"
		],
		"publishedAt": "2017-07-01"
	},
	{
		"description": "The grafana dashboard can now be configured to use an alternate client for authentication besides the `Auth0` client. This can help in scenarios where you want to expose instrumentation to other users in test environments.",
		"type": "added",
		"module": "Appliance",
		"release": "12628",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-07-01"
	},
	{
		"description": "Limitd buckets no longer require the entire configuration to be specified in the limitd configuration page. Only buckets that are different from the system default need to be specified.",
		"type": "added",
		"module": "Appliance",
		"release": "12628",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-07-01"
	},
	{
		"description": "Limitd buckets can be specifically removed (i.e. unlimited) via configuration.",
		"type": "added",
		"module": "Appliance",
		"release": "12628",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-07-01"
	},
	{
		"description": "Instrumentation, if enabled, now includes jitter during its collection process to avoid spiking the CPU during collection periods",
		"type": "fixed",
		"module": "Appliance",
		"release": "12628",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-07-01"
	},
	{
		"description": "telegraf and influxdb now do proper log rotation.",
		"type": "fixed",
		"module": "Appliance",
		"release": "12628",
		"team": [
			"rikaard.hosein"
		],
		"publishedAt": "2017-07-01"
	},
	{
		"description": "Certification uploads should now correctly trigger a change if either the key or the pem change.",
		"type": "fixed",
		"module": "Appliance",
		"release": "12628",
		"team": [
			"cristofer.gonzales"
		],
		"publishedAt": "2017-07-01"
	},
	{
		"description": "Dashboard admin invites will always go out with the configured default email as the send-from address. This could potentially break Dashboard Admin invite flows if there is no configured default send-from email address.",
		"type": "fixed",
		"module": "Appliance",
		"release": "12628",
		"team": [
			"crew-2"
		],
		"publishedAt": "2017-07-01"
	},
	{
		"description": "Support for GeoHA with Elasticsearch. This allows user search via Elasticsearch to be used in GeoHA environments.",
		"type": "added",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"silvio.massari",
			"rikaard.hosein"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "Logrotation added for elasticsearch. This should make sure logs are kept to a reasonable size, if Elasticsearch is enabled. The last 4 log files are retained.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"rikaard.hosein"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "Logrotation added for influxdb and telegraph. This should make sure logs are kept to a reasonable size, if instrumentation is enabled. The last 5 log files are retained.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"rikaard.hosein"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "Minimum master databases are now set properly for Elasticsearch on initial setup. This affects how many failed nodes ES requires to be available to maintain a writeable cluster.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "New version of limitd is available that addresses some memory leaks.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"jose"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "Nginx is now properly configured wtih the default server_names_hash_bucket size on initial installs.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "New event types are added to the statistics calculation in calculating active users.",
		"type": "added",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "Users can now be exported via the a0cli for a limited set of whitelisted fields.",
		"type": "added",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "Sensitive data is now required to be exported separately and stored seprately from standard backups. This keeps a better separation between keys and data. Both sets of backups are needed in order to succesfully complete restoration. Senstivie data is backuped up via the a0cli command line just like database backups.",
		"type": "added",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "Webtask components have been updated to the latest as of release time. While largely internal, it will allow the appliance to keep pace with the latest extensions.",
		"type": "added",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "Old webtask images are now automatically removed after an appliance update. Webtask keep the current images plus the one for one release prior, all others will be removed.",
		"type": "added",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "A sandbox error is no longer displayed in the manage UI if a sandbox other than auth0-sandbox is enabled.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "SSO timeout setting now applies users API endpoint.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11112",
		"team": [
			"cristofer.gonzales"
		],
		"publishedAt": "2017-03-21"
	},
	{
		"description": "Webtask Editor is now available in appliance. This allow you to edit webtask right from a web page. See https://webtask.io/docs/editor for more details on the editor.",
		"type": "added",
		"module": "Appliance",
		"release": "11112",
		"team": [
			"javier.centurion"
		],
		"publishedAt": "2017-03-21"
	},
	{
		"description": "Hooks Feature is now available in appliance. This allows you to plug in code on specific events. See <a href=\"https://auth0.com/docs/hooks\" rel=\"external\">https://auth0.com/docs/hooks</a> for more details.",
		"type": "added",
		"module": "Appliance",
		"release": "11112",
		"team": [
			"javier.centurion",
			"geoff"
		],
		"publishedAt": "2017-03-21"
	},
	{
		"description": "Webtask components have been updated. While mostly internal, this will allow the appliance to keep pace with the latest extensions.",
		"type": "added",
		"module": "Appliance",
		"release": "11112",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-03-21"
	},
	{
		"description": "Longer server name lengths can be accomodated in nginx via configuration.",
		"type": "added",
		"module": "Appliance",
		"release": "11112",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-03-21"
	},
	{
		"description": "Grafana no longer restricts users by domain name.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11112",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-03-21"
	},
	{
		"description": "Mongo2es service properly stops and does not uninstall when transitioning to or from Elasticsearch.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11112",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-03-21"
	},
	{
		"description": "auth0-server no longer logs sensitive data on failed requests",
		"type": "fixed",
		"module": "Appliance",
		"release": "10755",
		"team": [
			"eduardo.diaz"
		],
		"publishedAt": "2017-02-20"
	},
	{
		"description": "Sandbox parameters should be properly created if missing for a tenant",
		"type": "fixed",
		"module": "Appliance",
		"release": "10755",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-02-20"
	},
	{
		"description": "From configuration, can enable tenant verification prior to creation of tenant log collections.",
		"type": "added",
		"module": "Appliance",
		"release": "10755",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2017-02-20"
	},
	{
		"description": "Mongo client updated to 3.2 and added scripts to update the mongo database to 3.2",
		"type": "added",
		"module": "Appliance",
		"release": "10755",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2017-02-20"
	},
	{
		"description": "Users modified/updated via the Users api are now properly forwarded to ElasticSearch, if enabled.",
		"type": "fixed",
		"module": "Appliance",
		"release": "10755",
		"team": [
			"rikaard.hosein"
		],
		"publishedAt": "2017-02-20"
	},
	{
		"description": "Usage calculations have now been updated to include breakdown per tenant per client per conneciton per strategy per month.",
		"type": "added",
		"module": "Appliance",
		"release": "10755",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-02-20"
	},
	{
		"description": "The new authentication pipeline is now included.  Please verify major auth flows before moving it to production.",
		"type": "added",
		"module": "Appliance",
		"release": "10755",
		"team": [
			"crew-auth"
		],
		"publishedAt": "2017-02-20"
	},
	{
		"description": "Webtask runtime components have been updated to 18.3.2",
		"type": "added",
		"module": "Appliance",
		"release": "10755",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-02-20"
	},
	{
		"description": "Elasticsearch Preview is now available to some customers as a limited release.",
		"type": "added",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"silvio.massari",
			"rikaard.hosein"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "Webtask runtime components have been updated to 17.3.5",
		"type": "added",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "Webtask domain must now be setup as part of initial appliance node setup.",
		"type": "added",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "Logs should not be truncated during configuration updates.",
		"type": "fixed",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "Webtask configuration overrides are now properly merged with standard default values.",
		"type": "fixed",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "The default smtp address is used for emails from 2nd level brute force notifications.",
		"type": "fixed",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "apt-mirror.it.auth0.com is now access via https instead of http.",
		"type": "fixed",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "Auth0 Docs use the correct client secret so will now show up.",
		"type": "fixed",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "Use of the user search hint and user search timeout can now be modified if needed",
		"type": "added",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "API2 CPU and Memory limits can now be set, like for other services.",
		"type": "added",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"rikaard.hosein"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "auth0-stats no longer hands on single-replica instances",
		"type": "fixed",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"dirceu"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "The default redirect url can now be configure",
		"type": "fixed",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "Internet connectivity healthcheck moved from ping to HTTP HEAD request",
		"type": "fixed",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "api v1 has been split from `auth0-server` to run from a separate service, `auth0-api1`.",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"jose"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Ensure dhcpclient is stopped when switching networking from dynamic to static",
		"type": "fixed",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Webtask endpoints added to healthchecks for Appliance. ",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Appliance will no longer forward arbitrary `fwd.` parameters for authentication requests.",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"silvio.massari",
			"hernan.tierno"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Add-as-arbiter scripts have been extended to support two-arbiter configurations",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"carlos.mostek"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Fixed a mis-match in per_page limits on user searches.",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "The appliance can be setup to us proxies on initial install and during updates.",
		"type": "fixed",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Encryption and hashing keys are rotated during initial appliance setup when `set-as-first` is run.",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "During re-configuration, webtask should be restarted only when necessary.",
		"type": "fixed",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Instrumentation metrics can now be sent to a DataDog endpoint by providing a DataDog API Key in configuration.",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"silvio.massari",
			"rikaard.hosein"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Azure WAAD thumbprints are now automatically updated nightly from one of the appliance nodes.",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "The multifactor auth link now links to #/multifactor instead of #/guardian",
		"type": "fixed",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Webtask on the appliance is now upgraded to version 14.5.1.",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"pablo.terradillos",
			"tomek"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Per node instrumentation is now available. Instrumentation provides historical data and a UX for the node that shows system metrics, database metrics, and transaction rates. Detailed instrumentation for 24 hours is retained, and down-sampled metrics are available for 7 days.",
		"type": "added",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"silvio",
			"rikaard.hosein"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "Extensions are now supported. You must have configured webtasks (auth0-sandbox mode) for extensions to work, and a certificate issued by a public certificate authority. A few extensions from the public cloud do not work on the appliance, and you will not see those extensions in the extensions gallery.",
		"type": "added",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"javier.centurion",
			"pablo.terradillos",
			"tomek"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "You can configure log retention in the dashboard. The log retention period applies to all tenants, and defaults to 30 days. Performance can be adversely affected by setting this beyond 30 days. Please consult your CSE.",
		"type": "added",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"chris"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "You can disable http for authenticated health checks in the management dashboard. By default both http and https are allowed, with the http interface intended for use on isolated networks. If you aren't on an isolated network or only want to allow https, then you can disable http.",
		"type": "added",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "The docker repository can now use port 443 instead of port 5000 for getting updates. In some environments using a non-standard port was problematic.",
		"type": "added",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "Improved CLI scriptability by always returning 0 on success, and 1 on failure. Also standardized output for commands, and error handling. The CLI also now automatically updates to the metadata version for the cluster release.",
		"type": "changed",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "You can now add trusted certificates to the cert store on the appliance. This helps for certain situations, like the use of a transparent proxy.",
		"type": "added",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "Added a posture check to the configuration process. This ensures that the services came up correctly after configuration, and that all configuration has completed running.",
		"type": "added",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "The client credentials authentication flow no longer depends upon webtasks.",
		"type": "fixed",
		"module": "Appliance",
		"release": "8986",
		"team": [],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "Appliance tenants are now created as premium customers.",
		"type": "fixed",
		"module": "Appliance",
		"release": "8986",
		"team": [],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "When using proxy protocol (typically AWS), tenant logs fail when auth0-sandbox is configured (webtasks).",
		"type": "fixed",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "The consistency checks at startup for tty1 (auth0-start) forced an application update sometimes when first adding a node to an operating cluster. These checks now only warn.",
		"type": "fixed",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"chris"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "The update process sometimes failed when both configuration and app updates are indicated. The app update is applied first, and it may in some circumstances apply invalid settings, causing a failure. Now configuration updates are always applied before application updates.",
		"type": "fixed",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"chris"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "Customers can disable TLS for SMTP. Normally Auth0 servers negotation TlS with SMTP servers using START_TLS. In some cases customers want to actively disable the use of TLS. You can now force TLS off for SMTP.",
		"type": "added",
		"module": "Appliance",
		"release": "8293",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2016-09-01"
	},
	{
		"description": "Performance fixes and enhancements.",
		"type": "changed",
		"module": "Appliance",
		"release": "8293",
		"team": [
			"chris",
			"pablo.terradillos",
			"bob.brumfield",
			"silvio"
		],
		"publishedAt": "2016-09-01"
	},
	{
		"description": "Filtering of patch releases done improperly, resulting in update to the latest version rather than selected version in some cases.",
		"type": "fixed",
		"module": "Appliance",
		"release": "8293",
		"team": [
			"chris"
		],
		"publishedAt": "2016-09-01"
	},
	{
		"description": "Open logout redirects are now disabled by default on new appliances. Logout redirects must be white listed.",
		"type": "changed",
		"module": "Appliance",
		"release": "7941",
		"team": [
			"chris",
			"pablo.terradillos"
		],
		"publishedAt": "2016-08-08"
	},
	{
		"description": "Webtasks are now enabled by default on new installations for rule execution.",
		"type": "changed",
		"module": "Appliance",
		"release": "7941",
		"team": [
			"chris",
			"pablo.terradillos"
		],
		"publishedAt": "2016-08-08"
	},
	{
		"description": "A connectivity command can now be ran against an instance in the cluster using the CLI to verify connecting on a ip address and port for each node.",
		"type": "added",
		"module": "Appliance",
		"release": "7941",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2016-08-08"
	},
	{
		"description": "A nslookup command can now be ran against an instance in the cluster using the CLI to verify dns setup for each node.",
		"type": "added",
		"module": "Appliance",
		"release": "7941",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2016-08-08"
	},
	{
		"description": "CSE can now adjust the maximum memory for several processes that can vary under load to match the profiles being used by the customer.",
		"type": "added",
		"module": "Appliance",
		"release": "7941",
		"team": [
			"chris"
		],
		"publishedAt": "2016-08-08"
	},
	{
		"description": "An additional fix was made to backup decompression logic.",
		"type": "added",
		"module": "Appliance",
		"release": "7941",
		"team": [
			"chris"
		],
		"publishedAt": "2016-08-08"
	},
	{
		"description": "Increased keep-alive timeout to 100 seconds. Some technologies like .NET use a 100 second timeout limit, and the previous setting of 60 seconds could cause issues.",
		"type": "fixed",
		"module": "Appliance",
		"release": "7760",
		"team": [
			"chris"
		],
		"publishedAt": "2016-07-27"
	},
	{
		"description": "Added a default from email address. If a template does not specify a from address then this address is used. Additionally there is an option to send dashboard administrator invitations from the default email address rather than the inviting administrator. This helps customers using transactional email services where they must white list from email addresses.",
		"type": "added",
		"module": "Appliance",
		"release": "7760",
		"team": [
			"chris"
		],
		"publishedAt": "2016-07-27"
	},
	{
		"description": "Added the ability to turn off MX record checking for email recipients. In some cases customers use domains that do not have MX records for emails.",
		"type": "added",
		"module": "Appliance",
		"release": "7760",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2016-07-27"
	},
	{
		"description": "The CLI would fail if an invalid key was specified for a user in the management dashboard. This fixes provides a clearer message and performs key checking.",
		"type": "fixed",
		"module": "Appliance",
		"release": "7760",
		"publishedAt": "2016-07-27"
	},
	{
		"description": "Improved diagnostics and troubleshooting view by adding RabbitMQ to service checks and showing each cluster node application version in the node view. RabbitMQ is responsible for queuing emails, and if it stops email will not be sent. This check now shows the status in the dashboard and also at the healthcheck endpoint.",
		"type": "added",
		"module": "Appliance",
		"release": "7760",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2016-07-27"
	},
	{
		"description": "Bulk user import now works on the appliance. Customers that have to import a large number of users can use the apiv2 mechanism for bulk user import.",
		"type": "added",
		"module": "Appliance",
		"release": "7760",
		"team": [
			"silvio"
		],
		"publishedAt": "2016-07-27"
	},
	{
		"description": "Fixed an issue with invalid compression on large backups.",
		"type": "fixed",
		"module": "Appliance",
		"release": "7760",
		"publishedAt": "2016-07-27"
	},
	{
		"description": "Information on response times for different authentication stages are now written to the logs. This helps customers understand where bottlenecks are occurring if logins are slow.",
		"type": "added",
		"module": "Appliance",
		"release": "7760",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2016-06-17"
	},
	{
		"description": "Search queries for users and transaction logs can execute on a secondary database instance. This reduces the load on the primary database node, ensuring that authentication transactions are not affected by expensive search queries in high load environments.",
		"type": "added",
		"module": "Search",
		"release": "7247",
		"team": [
			"silvio"
		],
		"publishedAt": "2016-06-17"
	},
	{
		"description": "The management dashboard can now use a different SSL certificate than the tenant authentication domains. With this feature you could for example run your authentication endpoints on externally facing domains while using an internal domain for the dashboard.",
		"type": "added",
		"module": "Dashboard",
		"release": "7247",
		"team": [
			"chris"
		],
		"publishedAt": "2016-06-17"
	},
	{
		"description": "The apiv1 user search endpoint caches results of a count operation for 5 minutes. The number of users should be considered an approximate count when doing search operations using apiv1.",
		"type": "fixed",
		"module": "Appliance",
		"release": "7247",
		"team": [
			"jose"
		],
		"publishedAt": "2016-06-17"
	},
	{
		"description": "Support for SSL offloading is now available. You can now configure the appliance to accept http. Your load balancer needs to provide a X-Forwarded-Proto header with this feature. The operational environment is responsible for ensuring http access is locked down to the load balancer.",
		"type": "added",
		"module": "Appliance",
		"release": "7247",
		"team": [
			"chris"
		],
		"publishedAt": "2016-06-17"
	},
	{
		"description": "For queries that return a large number of results, the apiv2 user search endpoint will not return a count if a time limit for counting matching users is exceeded. Doing overall count queries, or count queries for a connection are efficient and will return results even when there are millions of users.",
		"type": "fixed",
		"module": "Management API",
		"release": "7247",
		"team": [
			"jose"
		],
		"publishedAt": "2016-06-17"
	},
	{
		"description": "Auth0 now periodically collects aggregate statistics from appliance clusters. Customers can request a dump of the statistics collected.",
		"type": "added",
		"module": "Stats",
		"release": "7247",
		"team": [
			"bob.brumfield"
		],
		"publishedAt": "2016-06-17"
	},
	{
		"description": "Webtasks improve the execution of rules and custom database logic. Webtasks perform much better than the current 'node sandbox' mode and provide much better isolation than the optional 'eval' mode. Webtasks have many more node.js modules available for your rule logic to use.",
		"type": "added",
		"module": "Rules",
		"team": [
			"pablo.terradillos",
			"tomek"
		],
		"publishedAt": "2016-06-17"
	},
	{
		"description": "Performance of the management dashboard and user search improved. User search functionality is reduced as part of the performance improvement. You can now only sort users by email when doing a filtered search, and you can no longer sort by name or login count.",
		"type": "changed",
		"module": "Appliance",
		"release": "6975",
		"team": [
			"silvio.massari",
			"bob.brumfield",
			"pablo.terradillos",
			"chris"
		],
		"publishedAt": "2016-05-28"
	},
	{
		"description": "The CLI backup capability has been enhanced. You now will designate a specific instance for backup from the CLI. This ensures a backup does not degrade your normal cluster operations during the process. Additionally you must now have a dedicated backup volume on the designated backup instance. This ensures that a backup will not fill up volumes used for normal operations.",
		"type": "added",
		"module": "appliance",
		"release": "6868",
		"team": [
			"silvio.massari",
			"bob.brumfield",
			"pablo.terradillos",
			"chris"
		],
		"publishedAt": "2016-05-20"
	},
	{
		"description": "A CSE can now configure an appliance cluster to distribute load over more cores to support scale up as an alternative to scale out. Some types of authentications require expensive cryptographic operations where scale up may be a more desirable approach.",
		"type": "added",
		"module": "appliance",
		"release": "6868",
		"team": [
			"silvio.massari",
			"bob.brumfield",
			"pablo.terradillos",
			"chris"
		],
		"publishedAt": "2016-05-20"
	},
	{
		"description": "Services are now periodically checked and restarted by an independent process. Typically services do restart automatically, although in some unusual rapid failure modes a service may stop running. The monitoring service checks periodically for this condition and start any services that have failed their normal automatic restart. This additional monitoring function is off by default.",
		"type": "added",
		"module": "appliance",
		"release": "6868",
		"team": [
			"silvio.massari",
			"bob.brumfield",
			"pablo.terradillos",
			"chris"
		],
		"publishedAt": "2016-05-20"
	},
	{
		"description": "In this release a JSONP endpoint used for SSO has been disabled. This endpoint supported browsers before IE9. This exposes some potential vulnerabilities due to the weakness in the JSON protocol. A setting was also added that allows a customer to overrride the JSON disable on a per-tenant basis.",
		"type": "deprecated",
		"module": "appliance",
		"release": "6868",
		"team": [
			"silvio.massari",
			"bob.brumfield",
			"pablo.terradillos",
			"chris"
		],
		"publishedAt": "2016-05-20"
	},
	{
		"description": "Provided access to the language in passwordless email templates",
		"type": "added",
		"module": "Passwordless emails",
		"team": [
			"eduardo.diaz"
		],
		"publishedAt": "2016-05-12"
	},
	{
		"description": "Added support for Bitbucket and Dropbox social connections.",
		"type": "added",
		"module": "Social Connections: Bitbucket, Social Connections: Dropbox",
		"team": [
			"gabriel",
			"victor",
			"richard.seldon"
		],
		"publishedAt": "2016-05-12"
	},
	{
		"description": "Remove support for JSONP on /ssodata endpoint. The \"Last time you logged in with\" feature will no longer be supported on IE 9.",
		"type": "removed",
		"module": "API",
		"team": [
			"jose"
		],
		"publishedAt": "2016-05-10"
	},
	{
		"description": "The VMWare image (OVA) now supports compatibility level 10. If you have an older version of ESX, we can still provide an OVA with compatibility level 8.",
		"type": "added",
		"module": "Appliance",
		"release": "6576",
		"team": [
			"chris"
		],
		"publishedAt": "2016-05-05"
	},
	{
		"description": "Added the ability to re-assign IP addresses for other cluster nodes using the command line interface. When a cluster is moved to a new network, then the nodes need to be provided with the ip addresses of the other nodes in order to re-establish the cluster. With the **re-ip** command, you can modify a node configuration for the ip addresses of the other nodes in the cluster.",
		"type": "added",
		"module": "Appliance",
		"release": "6576",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2016-05-05"
	},
	{
		"description": "Rate limiting is a feature that is now available on the appliance. Rate limiting uses a token bucket approach to limit the rates on various services such as user logins and API invocations. The feature helps prevent against brute force attacks.",
		"type": "added",
		"module": "Appliance",
		"release": "6576",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2016-05-02"
	},
	{
		"description": "Added logout `returnTo` URL validation. If the `returnTo` URL is not in the Allowed Logout URLs list, the request will be rejected. See the [docs](https://auth0.com/docs/logout#setting-allowed-logout-urls-at-the-account-level) for more information.",
		"type": "added",
		"module": "Server",
		"release": "6576",
		"team": [
			"hernan.tierno"
		],
		"publishedAt": "2016-04-22"
	},
	{
		"description": "Added a new property on the **client** entity to allow users to specify how the client is going to perform authentication with the token endpoint. Values are `none`, `client_secret_post` and `client_secret_basic`. The `none` option is introduced for native applications which canâ€™t store secrets and use **PKCE** (see https://tools.ietf.org/html/rfc7636)",
		"type": "added",
		"module": "Management API",
		"team": [
			"martin.cabral"
		],
		"publishedAt": "2016-04-07"
	},
	{
		"description": "Suppressed the error message in the change password flow in order to prevent user enumeration within the message. The API now returns HTTP 200.",
		"type": "changed",
		"module": "Connections: Database",
		"team": [
			"marcos.castany"
		],
		"publishedAt": "2016-04-06"
	},
	{
		"description": "We included an extra validation in the `/tokeninfo` endpoint to verify that the account name in the URL matches the account for which the token was issued. Any call to the tokeninfo with a token from another account will return Unauthorized.",
		"type": "fixed",
		"module": "Authentication API",
		"team": [
			"sebastian.iacomuzzi",
			"marcos.castany"
		],
		"publishedAt": "2016-04-06"
	},
	{
		"description": "We deprecated the `current_user_device_credentials` scopes in the `/api/v2/device-credentials` endpoint for `POST` and `DELETE` methods. To use this endpoint we enabled **Basic authentication** with username and password from a database connection.",
		"type": "deprecated",
		"module": "APIv2",
		"team": [
			"sebastian.iacomuzzi",
			"marcos.castany"
		],
		"publishedAt": "2016-04-05"
	},
	{
		"description": "Geospatial information in audit log for audit login events is now available on the appliance. Previously geocoding was only available in the cloud.",
		"type": "added",
		"module": "Appliance",
		"team": [
			"chris"
		],
		"publishedAt": "2016-03-17"
	},
	{
		"description": "From the dashboard you can now test connectivity from an appliance instance to an IP address or DNS name and port. This enables you to see if low level connectivity exists between the appliance and other services like smtp or dns.",
		"type": "added",
		"module": "Appliance",
		"release": "5970",
		"team": [
			"pablo.terradillos"
		],
		"publishedAt": "2016-03-17"
	},
	{
		"description": "Application and setting updates now provide clearer log output. \r\n\r\nApplication updates also apply system updates, and apply configuration after update to ensure the  appliance is in a consistent state. Application updates at `apt-mirror.it.auth0.com` which resolves to a small number of IP addresses to whitelist during update. System updates can be overridden to always come from the central mirror using a setting override in the dashboard (mirror url). \r\n\r\nIn the future the use of the central mirror will be included automatically for a release into the application update pipeline.",
		"type": "changed",
		"module": "Appliance",
		"release": "5970",
		"team": [
			"chris"
		],
		"publishedAt": "2016-03-17"
	},
	{
		"description": "You can now programmatically query healthcheck endpoints (`/health/status/`) on CPU, memory, disk, services, network, internet, email, database and replica status. The service will return a `204` return code if OK, and a `520` return code if it is failing. If it is queried too frequently you may also get a `429` (_Too Many Requests_). You need to provide an API key (generated in the dashboard) in order to access these metrics.",
		"type": "added",
		"module": "Appliance",
		"release": "5970",
		"team": [
			"silvio.massari",
			"hernan.tierno"
		],
		"publishedAt": "2016-03-17"
	},
	{
		"description": "The Management Dashboard can be configured to run on a different port than 443. This way the manage dashboard will not be accessible with other services and can be blocked from external access.",
		"type": "changed",
		"module": "Appliance",
		"release": "5970",
		"team": [
			"silvio.massari"
		],
		"publishedAt": "2016-03-17"
	},
	{
		"description": "New command line interface for interacting with nodes in the appliance. \r\n\r\nThis is a beta release. The tool lets administrators automate tasks for the appliance and address specific nodes in the cluster. The beta release provides a commands to:\r\n* *ping* - Test connectivity to a server. Responds with pong, which confirms the end to end network and security connectivity are in place.\r\n* *create-key* - The CLI performs privileged operations, so a public/private key pair are used. You register the public key on the cluster through the dashboard. You can have multiple clients.\r\n* *backup-start* - This starts a backup on a cluster instance. If a backup already exists, it will be overwritten.\r\n* *backup-status* - Poll appliance for completion status\r\n* *backup-retrieve* - Retrieve a backup from the appliance so that you can store it off.\r\n\r\nRight now restores are performed manually working with a CSE if required.",
		"type": "added",
		"module": "Appliance",
		"release": "5970",
		"team": [
			"pablo.terradillos",
			"silvio.massari"
		],
		"publishedAt": "2016-03-17"
	},
	{
		"description": "Users can now specify a list of URLs that are valid to redirect to after logging out from Auth0. The update can be done either from the [Dashboard](https://manage.auth0.com/#/account/advanced) or using the  [Management API](https://auth0.com/docs/api/v2#!/Tenants/patch_settings).",
		"type": "added",
		"module": "Dashboard / Management API",
		"release": "5970",
		"team": [
			"hernan.tierno",
			"tomas.chernov",
			"cristian"
		],
		"publishedAt": "2016-03-15"
	},
	{
		"description": "Added new `ext_nested_groups` option to `waad` connection strategy. When both `ext_groups` and `ext_nested_groups` are enabled we return all the groups that the user is a member of instead of only returning the ones that the user is direct member (for more information see this [MSDN article]( https://msdn.microsoft.com/Library/Azure/Ad/Graph/api/users-operations#UserFunctions))",
		"type": "added",
		"module": "Enterprise Connections",
		"release": "5970",
		"team": [
			"marcos.castany"
		],
		"publishedAt": "2016-03-15"
	},
	{
		"description": "The `device-credentials` endpoint now supports basic authentication to perform `GET`, `POST`, and `DELETE` requests.",
		"type": "added",
		"module": "Management API",
		"release": "5970",
		"team": [
			"sebastian.iacomuzzi",
			"marcos.castany"
		],
		"publishedAt": "2016-03-14"
	},
	{
		"description": "Added Profile Mapper for the integrated **AD-LDAP** appliance functionality so you can map attributes coming from your AD-LDAP source to the users Auth0 profile.",
		"type": "added",
		"module": "Appliance",
		"release": "5970",
		"team": [
			"jose",
			"pablo.terradillos"
		],
		"publishedAt": "2016-03-07"
	},
	{
		"description": "The flow to reset a password has been updated. \r\n\r\nIn this new flow, users enter their username or email address and receive an email with instructions to choose a new password. The old flow which required users to enter their new password and then confirm the change via email is still available but has been deprecated: it is no longer available for new tenants and existing tenants are recommended to disable it.",
		"type": "changed",
		"module": "Auth0 Lock v9",
		"release": "5970",
		"team": [
			"sebastian.iacomuzzi",
			"gabriel",
			"ricky",
			"benjamin"
		],
		"publishedAt": "2016-03-01"
	},
	{
		"description": "Users can query logs using the **Management API v2**. \r\n\r\nYou can use the new `logs` endpoints to query logs. This is the new recommended way to query logs. The **API v1** logs endpoints will still be functional. See more info in the [docs](https://auth0.com/docs/api/v2#!/Logs/get_logs).",
		"type": "added",
		"module": "Management API",
		"release": "5970",
		"team": [
			"hernan.tierno"
		],
		"publishedAt": "2016-02-26"
	},
	{
		"description": "Appliance **Configuration** has its own landing page. Unauthorized users are redirected to the Dashboard",
		"type": "added",
		"module": "appliance",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Added the ability to configure a cluster from the **tty1** interface",
		"type": "added",
		"module": "appliance",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "The **Management API** supports the query (\"q\") parameter when searching for users",
		"type": "added",
		"module": "appliance",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Enabled appliance update through a proxy",
		"type": "added",
		"module": "appliance",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Support to handle **base64** encoded secret in the SMS provider",
		"type": "added",
		"module": "users",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Full support for SAMLP logout",
		"type": "added",
		"module": "logout",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Replica set Health check status available in the **Configuration** section",
		"type": "added",
		"module": "appliance",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Settings page reorganized in logical sections. **Federated Logout** setting available; if is enabled",
		"type": "changed",
		"module": "appliance",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Moved **AD/LDAP** connection under the configuration section.",
		"type": "changed",
		"module": "appliance",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "In API (v1), `profileData` is returned for linked identities",
		"type": "fixed",
		"module": "api",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "New look & feel for the **Password change** form and **Email verification** page",
		"type": "changed",
		"module": "login-page",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "If a ticket throws an error use the tenant's custom error page (if available)",
		"type": "changed",
		"module": "errors",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Modify User details to not disclose access tokens from IDPs",
		"type": "fixed",
		"module": "dashboard",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "`/authorize` endpoint now accepts `auth_type` parameter for use with **Facebook**",
		"type": "fixed",
		"module": "social-connections",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Added support for custom domains  https://github.com/auth0/auth0-users/pull/406",
		"type": "added",
		"module": "appliance",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Ability to reboot instance from dashboard",
		"type": "added",
		"module": "appliance",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Possibility to remove an application node under **Configuration** section",
		"type": "added",
		"module": "appliance",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Notifications to point to **Activity** section when it's required",
		"type": "added",
		"module": "appliance",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "**Activity** section for the appliance which will display the logs for any",
		"type": "added",
		"module": "appliance",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Ability to provide password after mail is sent via a `password change link` in the body of the mail.",
		"type": "added",
		"module": "dashboard",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Give the possibility to unblock a user that was automatically blocked by brute force",
		"type": "added",
		"module": "dashboard",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "**Change your SAML configuration** rule under **SAML** category",
		"type": "added",
		"module": "dashboard",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "URL to documentation page on some enterprise connections",
		"type": "fixed",
		"module": "dashboard",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Use the tenant logo in the authorize consent popup",
		"type": "added",
		"module": "oauth2",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "User status [endpoint](https://auth0.com/docs/api/v2#!/User_Blocks/get_user_blocks_by_id): `GET\t/api/v2/user-blocks/{id}`, `DELETE /api/v2/user-blocks/{id}`",
		"type": "added",
		"module": "api",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "**Account Settings:** when changing from custom error page to generic error page a confirmation dialog is displayed",
		"type": "changed",
		"module": "dashboard",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Login screen to [Lock 8.1](https://auth0.com/lock)",
		"type": "changed",
		"module": "users",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Adds additional claims to `/userinfo` in OIDC strict mode. If **profile** scope was granted: `given_name`, `family_name`, `nickname`, `picture`, `gender` and `locale`. If **email** scope was granted: `email` and `email_verified`.",
		"type": "changed",
		"module": "oidc",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Appliance administrators are now able to select a specific version of Auth0 to update from the tty0",
		"type": "added",
		"module": "appliance",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "You can create custom login domains per tenant from Dashboard",
		"type": "added",
		"module": "appliance",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "You can configure Mobile settings for iOS and Android from the **Apps** section",
		"type": "added",
		"module": "dashboard",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "From the **General** tab within **Account Settings**, you can configure the \"Oops\" page for unhandled errors",
		"type": "added",
		"module": "dashboard",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "**Passwordless** connections are shown in the **Third Party Apps** section",
		"type": "added",
		"module": "dashboard",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "New switch to **enable/disable cache** for AD/LDAP connections",
		"type": "added",
		"module": "dashboard",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "For database connections, when enabling \"Use my own database\" it automatically disables \"Import Users to Auth0\" option",
		"type": "fixed",
		"module": "dashboard",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "Users from a custom agreement with Auth0 are able to create accounts that depends on a parent account",
		"type": "added",
		"module": "dashboard",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "For `/i/authorize` endpoint, skips user consent if the user has previously granted it",
		"type": "changed",
		"module": "api",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "New \"Oops\" page (for unhandled errors) that can be customized for your account",
		"type": "added",
		"module": "errors",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Dwolla and Shopify social connector toggles are now fixed",
		"type": "fixed",
		"module": "dashboard",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Fixed issue for database connections that caused import users script to not create users when signups were disabled",
		"type": "fixed",
		"module": "users",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Fixed a bug when the client has RS256 as JWT alg",
		"type": "fixed",
		"module": "mfa",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Fix to support changing `email` and `email_verified` for any user identity (not just the main one)",
		"type": "fixed",
		"module": "users",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Disabled query response mode for implicit authorization request. This only applies to the new pipeline for **oauth2/i/authorize**",
		"type": "changed",
		"module": "oauth2",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Users can now checkout a free plan without billing or credit card information",
		"type": "changed",
		"module": "billing",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Improved configuration navigation menu and section",
		"type": "changed",
		"module": "appliance",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Updated the look and feel for Google Authenticator",
		"type": "changed",
		"module": "mfa",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Revamped the UI of the Applications **Quick Start** section",
		"type": "changed",
		"module": "dashboard",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Updated sms connection to support liquid syntax",
		"type": "changed",
		"module": "sms",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "New pricing model under the subscription section. Additionally, added the ability to create different account subscriptions on sign-up.",
		"type": "changed",
		"module": "pricing",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Return error if audience is not allowed with google access token (this only applies to native mobile use cases)",
		"type": "changed",
		"module": "social-connections:google",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "`/userinfo` accepts JWT-encoded access tokens, in addition to existing opaque access tokens",
		"type": "added",
		"module": "api",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Added a new console option to display if the instance meets the minimum requirements",
		"type": "added",
		"module": "appliance",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Added reporting memory available in addition to memory free",
		"type": "added",
		"module": "appliance",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Added ability to refresh Health Check records in the **Configuration | Troubleshoot** tab",
		"type": "added",
		"module": "appliance",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Easier access to the built-in webtask account through a new sidebar menu",
		"type": "added",
		"module": "dashboard",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Fixed dashboard admin applications list not showing for invited users",
		"type": "fixed",
		"module": "dashboard",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Added the ability to turn off credentials (password hashes) caching for AD/LDAP connections",
		"type": "added",
		"module": "users",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Fixes to the appliance update process",
		"type": "fixed",
		"module": "on-prem",
		"release": "4341",
		"publishedAt": "2015-10-23"
	},
	{
		"description": "Added support for multi language SMS templates",
		"type": "added",
		"module": "sms",
		"release": "4323",
		"publishedAt": "2015-10-22"
	},
	{
		"description": "Added SAML signout protocol support",
		"type": "added",
		"module": "saml",
		"release": "4323",
		"publishedAt": "2015-10-22"
	},
	{
		"description": "Enabled brute force protection by default for passwordless connections and prevent opt out",
		"type": "security",
		"module": "general",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Added version pick list for appliance update",
		"type": "added",
		"module": "on-prem",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Allowed administrators to disable signup for passwordless",
		"type": "added",
		"module": "general",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Display ```app_metadata.name``` or ```user_metadata.name``` on user profile when available",
		"type": "added",
		"module": "dashboard",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Added ability to create diagnostics package in the **Configuration** screen > **Troubleshoot** tab for appliance",
		"type": "added",
		"module": "on-prem",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Added ability to search users by ```phone_number```",
		"type": "added",
		"module": "users-search",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "API now supports changing ```phone_number```, ```phone_number_verified``` and ```verify_phone_number``` when using the PATCH Users endpoint",
		"type": "added",
		"module": "api2",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "For passwordless emails, **HTML+Liquid** is the default selected syntax",
		"type": "changed",
		"module": "database-connections",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Fixed issue when going from multitenant to single tenant",
		"type": "fixed",
		"module": "on-prem",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Improved error messages when the password expires or when the password change is required",
		"type": "changed",
		"module": "ad-connector",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Improved the Users search by email",
		"type": "fixed",
		"module": "users-search",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Updated x509 library to support Mac OS X El Capitan",
		"type": "fixed",
		"module": "certificates",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Expanded documentation on [account linking](https://auth0.com/docs/link-accounts)",
		"type": "docs",
		"module": "link-accounts",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Added new [tutorial](https://auth0.com/docs/server-apis/relay) about Relay API",
		"type": "docs",
		"module": "docs",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Clarified steps for [Google authentication for Mobile devices](https://auth0.com/docs/native-platforms/android)",
		"type": "docs",
		"module": "docs",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Improved health check implementation to show multiple appliance nodes",
		"type": "added",
		"module": "on-prem",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Support multi tenancy enablement in the appliance dashboard",
		"type": "added",
		"module": "on-prem",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Add support for liquid templates for \"from\" and \"subject\" fields in user emails",
		"type": "added",
		"module": "emails",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Enable SSO and MFA session timeout configuration for appliance",
		"type": "added",
		"module": "on-prem",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "WS-Fed protocol: add more error details in logs",
		"type": "added",
		"module": "general",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Expose clients for a session in the context object so you know which applications a user has logged into",
		"type": "added",
		"module": "sso",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "liquid support for \"Redirect To\" url",
		"type": "added",
		"module": "emails",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added ability to edit user's email address in Users screen actions",
		"type": "added",
		"module": "dashboard",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Improved display of healthcheck information for appliance",
		"type": "added",
		"module": "on-prem",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added support for Liquid templates to Subject and From fields in email templates.",
		"type": "added",
		"module": "emails",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added nodes tab to the appliance configuration page for better visibility.",
		"type": "added",
		"module": "on-prem",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Dashboard log entries will now include user's IP address",
		"type": "added",
		"module": "dashboard",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "UI to manage SSO and MFA session",
		"type": "added",
		"module": "on-prem",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added [Nginx API Quickstart](https://auth0.com/docs/server-apis/nginx).",
		"type": "added",
		"module": "docs",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Improve examples of how to obtain `access_token` for account linking",
		"type": "added",
		"module": "link-accounts",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added and refactored documentation on User Profile and Tokens",
		"type": "added",
		"module": "docs",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added [Falcor API documentation](https://auth0.com/docs/server-apis/falcor)",
		"type": "added",
		"module": "docs",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Fix parameter names expected for Layer addon",
		"type": "fixed",
		"module": "apps",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Improve error handling on twitter connections",
		"type": "fixed",
		"module": "social-connections",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Fix validation of client IDs for connections to be less restrictive",
		"type": "fixed",
		"module": "dashboard",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Fix issues with create user when an ID had been used before",
		"type": "fixed",
		"module": "api2",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Fix case where empty search parameter passed to User Search",
		"type": "fixed",
		"module": "users-search",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Include error information in POST of SAMLResponse  StatusCode and StatusMessage fields instead of redirect with error description in query string.",
		"type": "fixed",
		"module": "saml",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Fixed issues with enterprise forms not properly updating samlp and fed metadata certs",
		"type": "fixed",
		"module": "dashboard",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Fixed an issue with the `user_id` when \"import users\" option used with custom database connection.",
		"type": "fixed",
		"module": "database-connections",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Fixed issue with selection of signing key for LDAP connections",
		"type": "fixed",
		"module": "ad-connector",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Fix XSS in login page with `authParams` argument.",
		"type": "security",
		"module": "login-page",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added HSTS header to HTTP responses.",
		"type": "security",
		"module": "general",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Allow a rule to be saved even if it contains an error",
		"type": "changed",
		"module": "rules",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Add support for [passwordless authentication](https://auth0.com/docs/connections/passwordless)",
		"type": "added",
		"module": "passwordless",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added documentation for [android](http://auth0.com/docs/libraries/lock-android/native-social-authentication)/[iOS](http://auth0.com/docs/libraries/lock-ios/native-social-authentication) on how to add whitelist of mobile client IDs for Google authentication for native applications",
		"type": "added",
		"module": "docs",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added support for Twitter's `force_login`.",
		"type": "added",
		"module": "social-connections:twitter",
		"release": "3615",
		"publishedAt": "2015-08-31"
	},
	{
		"description": "Support for the `wauth` parameter has been added.",
		"type": "added",
		"module": "wsfed",
		"release": "3615",
		"publishedAt": "2015-08-31"
	},
	{
		"description": "Added support for attribute blacklist (field `conn.options.non_persistent_attrs`). Attributes blacklisted wonâ€™t be persisted in our databases for that connection.",
		"type": "added",
		"module": "general",
		"release": "3615",
		"publishedAt": "2015-08-31"
	},
	{
		"description": "Multiple performance improvements.",
		"type": "fixed",
		"module": "api2",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Fixed connection update: custom options from connections were incorrectly removed.",
		"type": "fixed",
		"module": "connections",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Fixed unhandled error validating ip range.",
		"type": "fixed",
		"module": "enterprise-connections:ip",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "`PATCH /connections/:id:` prevent changing db customization if the connection has users.",
		"type": "fixed",
		"module": "api2",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Improved error descriptions.",
		"type": "fixed",
		"module": "popup",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Added `context.sso.with_auth0` and `context.sso.with_dbconn` attributes (see [protocols section](https://auth0.com/docs/rules)).",
		"type": "added",
		"module": "rules",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Support jwt for google-oauth2 added to `POST /oauth/access_token`",
		"type": "added",
		"module": "social-connections:google-oauth2",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Added `Allowed Mobile Client IDs` setting: Enable restricting connection token audience.",
		"type": "added",
		"module": "social-connections:google-oauth2",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Added [Azure AD native tutorial](https://auth0.com/docs/connections/enterprise/azure-active-directory-native).",
		"type": "added",
		"module": "docs",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "\"Use my own database\" (custom database) cannot be enabled for connections containing at least one user.",
		"type": "changed",
		"module": "database-connections",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Change password confirmation links can now only be used once.",
		"type": "changed",
		"module": "reset-password",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Added [Liquid](https://github.com/Shopify/liquid/wiki/Liquid-for-Designers) templating support.",
		"type": "fixed",
		"module": "emails",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "SSO between different database connections is now forbidden.",
		"type": "fixed",
		"module": "sso",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "When duplicate `name` or `client_id` occurs patching a connection status code 409 is now returned.",
		"type": "fixed",
		"module": "api2",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Fixed AD/LDAP Connector status not being displayed.",
		"type": "fixed",
		"module": "ad-ldap-connector",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Added support for [Untappd](https://untappd.com/) as a social connection.",
		"type": "added",
		"module": "social-connections",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Added `enabled_clients` field to PATCH connections responses",
		"type": "added",
		"module": "api2",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Added logic to prevent syntax errors in rules and database connection scripts",
		"type": "fixed",
		"module": "rules",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Improved error messages when changing password and deleting users of custom connections.",
		"type": "added",
		"module": "api2",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Added support for predefined `authParams` and `authParamsMap` parameters.",
		"type": "added",
		"module": "custom-oauth",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Added `lastUsedUserID` to `/user/ssodata` response",
		"type": "added",
		"module": "sso",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Improved connection error handling",
		"type": "added",
		"module": "social-connections:facebook",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Added `delete user` log events",
		"type": "added",
		"module": "logs",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Added debug button to custom database connections.",
		"type": "added",
		"module": "database-connections",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Added [Office 365 provisioning doc](https://auth0.com/docs/integrations/office-365-custom-provisioning)",
		"type": "added",
		"module": "docs",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Reading/writing signing keys is no longer allowed.",
		"type": "changed",
		"module": "keys",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "[appliance] Added timeout setting to the Auth0 Dashboard browser session. ![session timeout](https://cloud.githubusercontent.com/assets/178506/9208225/ad47e088-4048-11e5-8ae5-dea383f0fb9a.png)",
		"type": "added",
		"module": "configuration",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "[appliance] Improved the Auth0 Update UI. Added release notes of the version being downloaded (Online Update only). Added update events to Logs.",
		"type": "added",
		"module": "configuration",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "`POST /api/connections` now returns `enabled_clients` field in the response body.",
		"type": "fixed",
		"module": "api2",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Linked users are now taken into account when calculating stats.",
		"type": "fixed",
		"module": "api2",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Performance improvements for database logins.",
		"type": "fixed",
		"module": "general",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Removed `given_name`, `family_name`, `name`, `nickname` and `picture` properties from `POST /users`. Extra fields in the root user object are not longer allowed.",
		"type": "changed",
		"module": "api2",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Fixed unlinking users with the following ID format: `{provider}|{connection}|{id}`.",
		"type": "fixed",
		"module": "unlink",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Added support for encrypted configuration to connections.",
		"type": "added",
		"module": "api2",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Differentiate errors from sandbox from user's script errors.",
		"type": "added",
		"module": "rules",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Added documentation of tabs in [AD/LDAP Connector Admin Console](https://auth0.com/docs/connector/modify)",
		"type": "added",
		"module": "docs",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Documented [new events of Auth0 Lock](https://auth0.com/docs/libraries/lock/events)",
		"type": "added",
		"module": "docs",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Added support for JWT access tokens issued from Auth0 OAuth 2.0 endpoints",
		"type": "added",
		"module": "api2",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Replaced reset password bewits with tickets.",
		"type": "changed",
		"module": "reset-password",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Deleting an user now returns 204 HTTP status code.",
		"type": "changed",
		"module": "api2",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Using azp to retrieve client info for POST users request.",
		"type": "changed",
		"module": "api2",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Auth0 bewits are now encrypted",
		"type": "security",
		"module": "reset-password",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Added `PATCH /username`",
		"type": "added",
		"module": "api2",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Added logs for `warnings during login`.",
		"type": "added",
		"module": "logs",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Added `api_limit` logs.",
		"type": "added",
		"module": "logs",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Documented [Client certificates support in the AD/LDAP Connector](https://auth0.com/docs/connector/client-certificates)",
		"type": "added",
		"module": "ad-connector",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Added `limit_ui` (limit on userinfo) logs.",
		"type": "added",
		"module": "logs",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Improved docs for [Ember.js](https://auth0.com/docs/client-platforms/emberjs)",
		"type": "added",
		"module": "docs",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Updated [SharePoint support](https://auth0.com/docs/integrations/sharepoint)",
		"type": "added",
		"module": "sharepoint",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Updated [custom signup (using API2)](https://auth0.com/docs/custom-signup)",
		"type": "added",
		"module": "docs",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Updated [Ruby on Rails API Tutorial](https://auth0.com/docs/server-apis/rails) to use Knock gem",
		"type": "added",
		"module": "docs",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Documented [nodes available in the Auth0 appliance](https://auth0.com/docs/appliance/modules)",
		"type": "added",
		"module": "docs",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Improved error and log reporting.",
		"type": "fixed",
		"module": "errors",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Multiple performance improvements",
		"type": "fixed",
		"module": "general",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Fixed wildcards in subdomains on popup mode",
		"type": "fixed",
		"module": "popup",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Fixed impersonation flow to include all identity-specific fields",
		"type": "fixed",
		"module": "impersonate",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "[rules] Improved error handling of rules errors during login.",
		"type": "fixed",
		"module": "login",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Patched against SSL _Alternate Chains Certificate Forgery_ vulnerability.",
		"type": "security",
		"module": "security",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Explicitly fail when using JWTs on Headers that are more than 512 bytes long (applies to every endpoint except `/ro`).",
		"type": "changed",
		"module": "general",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Added rate limiting (and account blocking) for the `/ro` and the `/userinfo` endpoint",
		"type": "added",
		"module": "limitd",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Added debugging capabilities for rules",
		"type": "added",
		"module": "rules",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Added support for [passwordless connections](https://auth0.com/docs/connections/passwordless)",
		"type": "added",
		"module": "passwordless",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Added payment history and payment information",
		"type": "added",
		"module": "general",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Don't allow changing password and email or email_verified in same request",
		"type": "changed",
		"module": "api2",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Set username for connection without `requires_username` is now prevented",
		"type": "changed",
		"module": "api2",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Removing personal info fields from user patch",
		"type": "changed",
		"module": "api2",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Fixed utf8 encoding issues",
		"type": "fixed",
		"module": "login-page",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Fixed sort by connection when searching users",
		"type": "fixed",
		"module": "api2",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Fixed link account when \"sso with auth0\" is enabled",
		"type": "fixed",
		"module": "account-linking",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Added support for `last_password_reset` field.",
		"type": "added",
		"module": "import-users",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Added Connector article: [Creating a Test Active Directory Domain Controller](https://auth0.com/docs/connector/test-dc)",
		"type": "added",
		"module": "docs",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Improved search user experience",
		"type": "added",
		"module": "search",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Added information on [signing/encryption and IDP-initiated SSO](https://auth0.com/docs/saml-configuration#9)",
		"type": "added",
		"module": "saml",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Fixed Logjam vulnerability",
		"type": "security",
		"module": "security",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Fixed out-of-band write in utf8 decoder (v8 vulnerability)",
		"type": "security",
		"module": "api2",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Improved user search indexing.",
		"type": "fixed",
		"module": "users-search",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Fixed IE issues by Added P3P headers.",
		"type": "fixed",
		"module": "general",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Improved error messages when editing rules and deleting users.",
		"type": "fixed",
		"module": "rules",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Fixed tenant dropdown menu. (accounts with more than 10 tenants were not displayed correctly).",
		"type": "fixed",
		"module": "tenants",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "[performance] Improved UI performance by fetching resources from CDN.",
		"type": "fixed",
		"module": "dashboard",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Performance improvements for Auth0 connections.",
		"type": "fixed",
		"module": "database-connections",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Added schema info for add-ons: *Layer*, *AD RMS*, *MS CRM*, *Slack*.",
		"type": "added",
		"module": "api2",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Added `updated_at` property to users.",
		"type": "added",
		"module": "api2",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Updated rule templates.",
		"type": "added",
		"module": "dashboard",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Added delete script to custom database connections.",
		"type": "added",
		"module": "database-connections",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Added [documentation](https://auth0.com/docs/saml/identity-providers/salesforce) for SalesForce as IDP.",
		"type": "added",
		"module": "docs",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Multifactor Authentication now is featured in a [separate section](https://manage.auth0.com/#/multifactor).",
		"type": "changed",
		"module": "mfa",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Added [disable animations](https://auth0.com/docs/libraries/lock/ui-customization#2) in Lock section.",
		"type": "added",
		"module": "docs",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "`GET /users` methods now use `include_fields` instead of `exclude_fields`.",
		"type": "changed",
		"module": "api2",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Jobs when completed successfully return 200 HTTP status code.",
		"type": "changed",
		"module": "api2",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Tenant names are now limited to 64 characters.",
		"type": "changed",
		"module": "general",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Fixed multiple issues with samlp logout. (`nameid` has value only, no attribs)",
		"type": "fixed",
		"module": "samlp",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Updated [Auth0 Android documentation](https://auth0.com/docs/libraries/lock-android).",
		"type": "added",
		"module": "docs",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Added error codes for every API v2 error.",
		"type": "added",
		"module": "api2",
		"release": "2783",
		"publishedAt": "2015-05-29"
	},
	{
		"description": "Fixed: Failure to delete an user from auth0 Database Connection resulted in a 500 HTTP Stauts code.",
		"type": "fixed",
		"module": "api2",
		"release": "2783",
		"publishedAt": "2015-05-29"
	},
	{
		"description": "AD Connector: Added [admin dashboard section](https://auth0.com/docs/connector).",
		"type": "added",
		"module": "docs",
		"release": "2783",
		"publishedAt": "2015-05-29"
	},
	{
		"description": "Changed `exclude_fields` to `include_fields` for `GET /client` endpoints.",
		"type": "changed",
		"module": "api2",
		"release": "2783",
		"publishedAt": "2015-05-29"
	},
	{
		"description": "Positive assertions to read/write clients `jwtConfiguration.secretNotEncoded` and `custom_login_page_off`.",
		"type": "changed",
		"module": "api2",
		"release": "2783",
		"publishedAt": "2015-05-29"
	},
	{
		"description": "`POST /identity` takes connection_id not connection.",
		"type": "changed",
		"module": "api2",
		"release": "2783",
		"publishedAt": "2015-05-29"
	},
	{
		"description": "If email is PATCHed to the same value, and email_verified is not set then email_verified is taken from previous value.",
		"type": "fixed",
		"module": "api2",
		"release": "2783",
		"publishedAt": "2015-05-29"
	},
	{
		"description": "When creating an user, a custom made avatar with the initials is used if there is no gravatar picture associated with the email.",
		"type": "added",
		"module": "manage",
		"release": "2783",
		"publishedAt": "2015-05-29"
	},
	{
		"description": "Added error codes for endpoint logic.",
		"type": "added",
		"module": "api2",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Updated iOS, Swift and Objective C [mobile documentation](https://auth0.com/docs).",
		"type": "fixed",
		"module": "docs",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Updated login page template (solves CORS issues). Added polyfills for IE8/9.",
		"type": "fixed",
		"module": "login-page",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Improved SAMLP logout and added a samlp logout callback: use `client.addons.samlp.logout.callback` to set the HTTP POST url.",
		"type": "added",
		"module": "samlp",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Updated the Auth0 Lock version appliance uses to 7.5",
		"type": "added",
		"module": "lock",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Added Layer as an app addon",
		"type": "added",
		"module": "addons",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Now Auth0 API returns and accepts rules in the order they are applied.",
		"type": "changed",
		"module": "rules",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Property `options.scripts.fetchUserProfile` is now mandatory for oauth1/2 connections",
		"type": "changed",
		"module": "api2",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Setting `signing_keys` client property can only be done on global clients.",
		"type": "changed",
		"module": "api2",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "User POST or PATCH of email/password is no longer allowed for disabled connections.",
		"type": "changed",
		"module": "api2",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Added to Auth0.js docs [CORS section](https://auth0.com/docs/auth0js#16)",
		"type": "added",
		"module": "docs",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Added all clients to SSO cookie",
		"type": "added",
		"module": "sso",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Added [`POST /api/v2/device-credentials`](https://auth0.com/docs/apiv2#!/Device_Credentials/get_device_credentials) endpoint",
		"type": "added",
		"module": "api2",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Added support to change connection names.",
		"type": "added",
		"module": "api2",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Custom OAuth2 Examples: Added [Twitch IdP documentation](https://auth0.com/docs/oauth2-examples#6).",
		"type": "added",
		"module": "oauth2",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Added docs about [CMS integrations](https://auth0.com/docs/cms): Joomla and Wordpress docs.",
		"type": "added",
		"module": "docs",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Response Status Codes: Changed `400`: `already exists` to `409`.",
		"type": "changed",
		"module": "api2",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Changed devices endpoints to device-credentials",
		"type": "changed",
		"module": "api2",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Fixing XSS by introducing `@@config@@` replacement.   If you are using the default login page, you are not affected by this vulnerability and there is no action required on your behalf. Note: **The previous way of substituting variables in custom login pages will be deprecated by June 8th**. For more information contact us at [open a support ticket](https://support.auth0.com).",
		"type": "security",
		"module": "login-page",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Do not require state field when country does not have.",
		"type": "fixed",
		"module": "billing",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Ask for connection id instead of name in users bulk import",
		"type": "changed",
		"module": "api2",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Improved log details",
		"type": "added",
		"module": "logs",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Added section about [validating tokens to protocols](https://auth0.com/docs/protocols)",
		"type": "added",
		"module": "docs",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Fix log detail description which was shown as `[object Object]`.",
		"type": "fixed",
		"module": "logs",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Moved tickets endpoints to root from `/users/{id}/tickets/{type}` to `/tickets/{type}`",
		"type": "changed",
		"module": "api2",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "v2 ids are now limited to 16 alphanumeric characters.",
		"type": "changed",
		"module": "api2",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Now OpenID Connect is used by default (before it was WsFed)",
		"type": "changed",
		"module": "waad",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Added `user_tickets` scope",
		"type": "changed",
		"module": "api2",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Added `POST /api/v2/jobs/verification-email` endpoint to send emails to users so they verify their email accounts by clicking a link",
		"type": "added",
		"module": "api2",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Added logout for custom oauth1 and oauth2 strategies",
		"type": "added",
		"module": "custom-oauth",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Added UI to select protocol (wsfed vs. oidc) for Azure AD connections",
		"type": "added",
		"module": "waad",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Add ability to override client id and client secret for Window Azure AD connections.",
		"type": "added",
		"module": "waad",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Support for email verification and password change ticket. Added [`POST api/v2/users/{id}/tickets/email_verification`](https://auth0.com/docs/apiv2#!/users/post_email_verification) and [`POST api/v2/users/{id}/tickets/password_change`](https://auth0.com/docs/apiv2#!/users/post_password_change) endpoint for email verification and password change.",
		"type": "added",
		"module": "api2",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Fixed when creating a _New Rule_ it can be saved without editing it.",
		"type": "fixed",
		"module": "rules",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Fixed dashboard stuck when trying to access to a deleted app.",
		"type": "fixed",
		"module": "apps",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Added SAML metadata URL in advanced settings.",
		"type": "fixed",
		"module": "saml",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Disabled toggle and show notice for importing users to Auth0 when custom database is not enabled.",
		"type": "fixed",
		"module": "db-connections",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Preventing saving metadata on invalid json.",
		"type": "fixed",
		"module": "user-metadata",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Fixed Users > New User dialog not showing on IE10.",
		"type": "fixed",
		"module": "users",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Added warning when attempting to overwrite a secure key/value pair.",
		"type": "changed",
		"module": "rules",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Logs are no longer displayed exclusively to owners.",
		"type": "changed",
		"module": "logs",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Users without names or emails were not editable.",
		"type": "fixed",
		"module": "users",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Added field `conn.options.decryptionKey`.",
		"type": "added",
		"module": "samlp",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Added _redirect to_ and _url lifetime_ for blocked account emails.",
		"type": "added",
		"module": "emails",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Improved allowed callback URL validations.",
		"type": "fixed",
		"module": "manage",
		"release": "2479",
		"publishedAt": "2015-04-25"
	},
	{
		"description": "Fixed pagination issues on `users` section.  .",
		"type": "fixed",
		"module": "users",
		"release": "2479",
		"publishedAt": "2015-04-25"
	},
	{
		"description": "Added [devices endpoints](https://auth0.com/docs/apiv2#!/users/get_devices).",
		"type": "added",
		"module": "api2",
		"release": "2479",
		"publishedAt": "2015-04-25"
	},
	{
		"description": "Updated Auth0-laravel to be compatible with Laravel 5 docs: For more information check the [docs](https://auth0.com/docs/server-platforms/laravel) or the [tutorial](https://auth0.com/docs/server-apis/php-laravel).",
		"type": "added",
		"module": "docs",
		"release": "2479",
		"publishedAt": "2015-04-25"
	},
	{
		"description": "Added [SAML provisioning](https://auth0.com/docs/saml-configuration#10) section.",
		"type": "added",
		"module": "docs",
		"release": "2479",
		"publishedAt": "2015-04-25"
	},
	{
		"description": "Added [Email Providers](https://auth0.com/docs/email/providers) dashboard.",
		"type": "added",
		"module": "email-providers",
		"release": "2479",
		"publishedAt": "2015-04-25"
	},
	{
		"description": "Revamped User Metadata section.",
		"type": "added",
		"module": "dashboard",
		"release": "2425",
		"publishedAt": "2015-04-18"
	},
	{
		"description": "Added [React Native iOS tutorial](https://auth0.com/docs/native-platforms/ios-reactnative).",
		"type": "added",
		"module": "docs",
		"release": "2425",
		"publishedAt": "2015-04-18"
	},
	{
		"description": "Added [article](https://auth0.com/docs/metadata-in-rules) that explains how to work with user metadata in Rules.",
		"type": "added",
		"module": "docs",
		"release": "2425",
		"publishedAt": "2015-04-18"
	},
	{
		"description": "Updated email section to include: [Blocked Account Email](https://auth0.com/docs/email#12) and [URL Lifetime](https://auth0.com/docs/email#7)",
		"type": "added",
		"module": "docs",
		"release": "2425",
		"publishedAt": "2015-04-18"
	},
	{
		"description": "Added \"device_id\" to refresh tokens",
		"type": "added",
		"module": "refresh-token",
		"release": "2425",
		"publishedAt": "2015-04-18"
	},
	{
		"description": "Added multi-region support in tenant creation: Users can choose where their Auth0 accounts will be running (Current regions supported: *Europe Central* and *US West*).",
		"type": "added",
		"module": "general",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Added [master list of SAML apps Auth0 supports and their config](https://auth0.com/docs/saml-apps)",
		"type": "added",
		"module": "docs",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Added TTL to emails sent by Auth0",
		"type": "added",
		"module": "emails",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Fixed certificate upload errors in SAMLP Connections",
		"type": "fixed",
		"module": "samlp",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Added troubleshooting script to AD Connector ([docs](https://auth0.com/docs/connector/troubleshooting))",
		"type": "added",
		"module": "ad-connector",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Added [explanation of SAML roles and generic instructions for SAML configuration](https://auth0.com/docs/saml-configuration)",
		"type": "added",
		"module": "saml",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Added an easier way to search users in Auth0 ([docs](https://auth0.com/docs/users-search))",
		"type": "added",
		"module": "search",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Added linking and unlinking of identities: [`POST /api/v2/users/{id}/identities`](https://auth0.com/docs/apiv2#!/users/post_identities) and [`DELETE /api/v2/users/{id}/identities/{provider}/{user_id}`](https://auth0.com/docs/apiv2#!/users/delete_provider_by_user_id) endpoints",
		"type": "added",
		"module": "api2",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Fixed: Invited users were not able to see custom database rules",
		"type": "fixed",
		"module": "dashboard",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Email for social users cannot be updated",
		"type": "changed",
		"module": "api2",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Fixed security issue with path browsing when downloading sample projects from docs.",
		"type": "security",
		"module": "docs",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Added docs on [deployment models](https://auth0.com/docs/deployment)",
		"type": "added",
		"module": "docs",
		"release": "2274",
		"publishedAt": "2015-04-03"
	},
	{
		"description": "API Explorer for v2 [redesigned](https://docs.auth0.com/apiv2)",
		"type": "added",
		"module": "api2",
		"release": "2274",
		"publishedAt": "2015-04-03"
	},
	{
		"description": "Added [APIv2 /logout endpoint](https://auth0.com/docs/logout)",
		"type": "added",
		"module": "logout",
		"release": "2274",
		"publishedAt": "2015-04-03"
	},
	{
		"description": "Added Certificate Rollover: Auth0 detects when certificates expire on IdPs. When that happens, we automatically update the certificates or, if that is not possible, we send an email to the tenant owners to make manually the change.",
		"type": "added",
		"module": "certificates",
		"release": "2274",
		"publishedAt": "2015-04-03"
	},
	{
		"description": "Added documentation on [Email templates](https://auth0.com/docs/email), [Custom Email Flows](https://auth0.com/docs/email/custom) and [Using custom email providers](https://auth0.com/docs/email/providers)",
		"type": "added",
		"module": "docs",
		"release": "2274",
		"publishedAt": "2015-04-03"
	},
	{
		"description": "Added the ability to configure links TTL from email template",
		"type": "added",
		"module": "email",
		"release": "2274",
		"publishedAt": "2015-04-03"
	},
	{
		"description": "Credentials are no longer removed when linking a profile",
		"type": "fixed",
		"module": "link-accounts",
		"release": "2274",
		"publishedAt": "2015-04-03"
	},
	{
		"description": "Added flag to block accounts after a great number of failed attempts. The email \"account blocked\" email can be configured.",
		"type": "added",
		"module": "database-connections",
		"release": "2274",
		"publishedAt": "2015-04-03"
	},
	{
		"description": "Added example of how to use custom OAuth2 strategy with [imgur](https://auth0.com/docs/oauth2-examples#4)",
		"type": "added",
		"module": "docs",
		"release": "2223",
		"publishedAt": "2015-03-27"
	},
	{
		"description": "Allow SAML `RelayState` parameter",
		"type": "added",
		"module": "samlp",
		"release": "2223",
		"publishedAt": "2015-03-27"
	},
	{
		"description": "Added tabs for enabling/disabling a social-connection in app.",
		"type": "added",
		"module": "dashboard",
		"release": "2223",
		"publishedAt": "2015-03-27"
	},
	{
		"description": "Fixed confirm leaving edit user when the details are saved.",
		"type": "fixed",
		"module": "dashboard",
		"release": "2223",
		"publishedAt": "2015-03-27"
	},
	{
		"description": "Fixed email validation issue for emails with _",
		"type": "fixed",
		"module": "import",
		"release": "2223",
		"publishedAt": "2015-03-27"
	},
	{
		"description": "Added ability to sign SAML requests",
		"type": "added",
		"module": "samlp-connections",
		"release": "2223",
		"publishedAt": "2015-03-27"
	},
	{
		"description": "[api2] Custom Email Provider (Added [GET, POST, PATCH, DELETE /api/v2/emails/provider API2 endpoints](https://auth0.com/docs/apiv2#!/emails)):",
		"type": "added",
		"module": "emails",
		"release": "2223",
		"publishedAt": "2015-03-27"
	},
	{
		"description": "Auth0's [European Instance](https://manage.auth0.com/login) is now available",
		"type": "added",
		"module": "general",
		"release": "2223",
		"publishedAt": "2015-03-27"
	},
	{
		"description": "Added [password policy section](https://auth0.com/docs/custom-signup#5) to custom signup documentation",
		"type": "added",
		"module": "docs",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Added [How to setup DigitalOcean as a custom OAuth2 connection](https://auth0.com/docs/oauth2-examples#3)",
		"type": "added",
		"module": "docs",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Error handling improvements",
		"type": "fixed",
		"module": "salesforce",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Custom database invalid script broke UI.",
		"type": "fixed",
		"module": "database-connection",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Rejecting invalid emails in PUT /api/users/email",
		"type": "fixed",
		"module": "email",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Remove sms users for connection when connection is deleted",
		"type": "fixed",
		"module": "sms",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Fixed issue with redirect when response_type is token",
		"type": "fixed",
		"module": "general",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Remove sms users when removing tenant",
		"type": "fixed",
		"module": "sms",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Fixing XSS in `internalOptions` field.",
		"type": "security",
		"module": "custom-login-page",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Images are no longer inlined when emails are sent",
		"type": "changed",
		"module": "email",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "New forbidden metadata fields: `user_metadata` and `app_metadata`",
		"type": "changed",
		"module": "metadata",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Added [React.js tutorial](https://auth0.com/docs/client-platforms/react)",
		"type": "added",
		"module": "docs",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Multiple Shopify fixes.",
		"type": "fixed",
		"module": "shopify",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Custom DB script timeout error are now visible.",
		"type": "fixed",
		"module": "database-connection",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Update S3 file when deleting or changing connections",
		"type": "fixed",
		"module": "api2",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Updated components to use jsonwebtoken to 4.2.0",
		"type": "security",
		"module": "general",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Limitd in api v2",
		"type": "added",
		"module": "api2",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Added [`DELETE /api/v2/rules/{id}`](https://auth0.com/docs/apiv2#!/rules/delete_rules_by_id)",
		"type": "added",
		"module": "api2",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Added [Kerberos support documentation](https://auth0.com/docs/connector/kerberos)",
		"type": "added",
		"module": "docs",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Added option to re-send a verification e-mail to an user.",
		"type": "added",
		"module": "verification-email",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Performance: reduced number of requests to load connections.",
		"type": "fixed",
		"module": "dashboard",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Fixed page broken when submiting ADFS forms with an invalid file as cerificate",
		"type": "fixed",
		"module": "adfs",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Linkedin emails were always verified",
		"type": "changed",
		"module": "linkedin",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Added [`GET api/v2/rules`](https://auth0.com/docs/apiv2#!/rules/get_rules) endpoint",
		"type": "added",
		"module": "api2",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Added [`GET rules/{id}`](https://auth0.com/docs/apiv2#!/rules/get_rules_by_id) endpoint",
		"type": "added",
		"module": "api2",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Added [`POST /api/v2/rules`](https://auth0.com/docs/apiv2#!/rules/post_rules) endpoint",
		"type": "added",
		"module": "api2",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Added [`PATCH /api/v2/rules/{id}`](https://auth0.com/docs/apiv2#!/rules/patch_rules_by_id) endpoint",
		"type": "added",
		"module": "api2",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Fixed issue that caused creation of users in connections that require username to fail (Added max length for connection name)",
		"type": "fixed",
		"module": "api2",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Fixed issue with Lock Auth0 badge footer not being hidden on paid accounts.",
		"type": "fixed",
		"module": "pricing",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Users search implemented: [`GET /api/v2/users`](https://auth0.com/docs/apiv2#!/users/get_users).",
		"type": "added",
		"module": "api2",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Updated [documentation](https://auth0.com/docs/protocols) for WS-Fed endpoint",
		"type": "added",
		"module": "docs",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Fixed missing clientID on WS-Fed endpoint",
		"type": "fixed",
		"module": "wsfed",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Fix for Firefox switchboard checkboxes in [Social Connections](https://manage.auth0.com/#/connections/social)",
		"type": "fixed",
		"module": "social-connections",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Added [`PATCH connections/{id}`](https://auth0.com/docs/apiv2#!/users/patch_users_by_id) endpoint",
		"type": "added",
		"module": "api2",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Added [Office 365 integration docs](https://auth0.com/docs/integrations/office-365)",
		"type": "added",
		"module": "docs",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Added documentation for *[Rules source control using Github](https://auth0.com/docs/rules#8)*",
		"type": "added",
		"module": "rules",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Auth0 Proxy Updater: Operating System updates for intranet systems with no internet connection ([docs](https://auth0.com/docs/appliance/proxy-updater)).",
		"type": "added",
		"module": "on-prem",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Fixed [`DELETE /users`](https://auth0.com/docs/apiv2#!/users/delete_users) query performance",
		"type": "fixed",
		"module": "performance",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Fixed html entities escaping on reset and verify email endpoints when `tenant` or `clientID` were not found.",
		"type": "fixed",
		"module": "error-reporting",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Changed to use Open ID Connect instead of oauth2",
		"type": "changed",
		"module": "waad",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Updated Lock versions in docs and dashboard",
		"type": "changed",
		"module": "dashboard",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Fixed broken Twilio doc link",
		"type": "fixed",
		"module": "dashboard",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Fixed impersonated users flag",
		"type": "fixed",
		"module": "dashboard",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Fixed sap addon settings",
		"type": "fixed",
		"module": "dashboard",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Fixed signedUp check",
		"type": "fixed",
		"module": "dashboard",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "When calling /api/v2/clients the callback field was not returned",
		"type": "fixed",
		"module": "api2",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Removes SSLv3 support",
		"type": "security",
		"module": "general",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Use only global client for find user queries",
		"type": "fixed",
		"module": "api",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Fixed [`PUT /users`](https://auth0.com/docs/api#!#put--api-users--user_id--metadata) when payload does not have any properties",
		"type": "fixed",
		"module": "api",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Fixed pricing v3 cases",
		"type": "fixed",
		"module": "pricing",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Added [`GET /connections`](https://auth0.com/docs/apiv2#!/connections/get_connections)",
		"type": "added",
		"module": "api2",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Added generic Oauth1 strategy ([docs](https://auth0.com/docs/oauth1))",
		"type": "added",
		"module": "oauth1",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Added [`DELETE /connections/{id}`](https://auth0.com/docs/apiv2#!/connections/delete_connections_by_id)",
		"type": "added",
		"module": "api2",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Added [`POST /connections`](https://auth0.com/docs/apiv2#!/connections/post_connections)",
		"type": "added",
		"module": "api2",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Added logging for success signups for non-database connections",
		"type": "added",
		"module": "logs",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "Error messages are now displayed correctly on fail",
		"type": "fixed",
		"module": "rules",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "Small fixes",
		"type": "fixed",
		"module": "billing",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "Fixed: Navigating to different connections and then changing the switch for one of them changes it for all the ones visited.",
		"type": "fixed",
		"module": "database-connections",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "API Call [`PATCH /api/v2/users`](https://auth0.com/docs/apiv2#!/users/patch_users_by_id) now returns updated user.",
		"type": "changed",
		"module": "api2",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "Allow `whr` (Windows Home Realm) in the authParams",
		"type": "changed",
		"module": "waad",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "Added wreply to Azure Active Directory connection",
		"type": "changed",
		"module": "waad",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "Login page parameters were only replaced on their first occurence. For instance if the login page contained: `@@auth0Domain@@ @@auth0Domain@@` only the first placeholder was replaced: `auth0.com @@auth0Domain@@`.",
		"type": "fixed",
		"module": "login-page",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "In some conditions, [`DELETE /api/users/{user_id}`](https://auth0.com/docs/api#!#delete--api-users) was not removing the user correctly  .",
		"type": "fixed",
		"module": "api",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "Parameter `samlpOptions` is now required to be a valid JSON object.",
		"type": "changed",
		"module": "samlp",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "Added geoip property to default context object (without a geoip property, some rules may breaks, for instance: https://github.com/auth0/rules/blob/master/rules/add-country.md)",
		"type": "fixed",
		"module": "rules",
		"release": "1999",
		"publishedAt": "2015-02-20"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/changelog/appliance.json
// module id = 1372
// module chunks = 0